<div class="modal inmodal fade in parcel-modal create-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title col-sm-8">New Rule</h4>
                    <div class="input-group-btn pull-right">
                        <button tabindex="-1"
                                class="btn btn-primary submit"
                                type="submit"
                                [disabled]="disabledSubmit || settingsParkingPassesService.modalSpinnerShow">
                            Save
                        </button>
                        <button data-toggle="dropdown"
                                class="btn btn-primary dropdown-toggle"
                                type="button"
                                aria-expanded="false">
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu pull-right" style="z-index: 1001;">
                            <li><a (click)="hideModal()">Cancel</a></li>
                        </ul>
                    </div>
                </div>
                <div class="modal-body">
                    <!-- ___ Name ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Name</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <input class="form-control" name="name" [ngModel]="data.name" required>
                        </div>
                    </div>

                    <!-- ___ Internal ID ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Internal ID</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <input class="form-control" name="internalId" [ngModel]="data.internalId">
                        </div>
                    </div>

                    <!-- ___ Type ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Type</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <select class="form-control" name="type" [ngModel]="data.type" required>
                                <option value="general">General</option>
                                <option value="sliding">Sliding</option>
                            </select>
                        </div>
                    </div>

                    <!-- ___ Allow Residents To Book  ___ -->
                    <div class="row m-b-sm col-md-12">
                        <label class="img-checkbox">
                            <input id="allowResidentsToBook"
                                   type="checkbox"
                                   name="allowResidentsToBook"
                                   #allowResidentsToBook
                                   [ngModel]="data.allowResidentsToBook">
                            <label for="allowResidentsToBook"><svg-checked></svg-checked></label>
                            <span>Allow Residents To Book</span>
                        </label>
                    </div>

                    <!-- ___ Buildings  ___ -->
                    <div class="row m-b-sm" style="overflow: visible;">
                        <div class="col-md-4 m-t-xs apart-btns">
                            <label>Applies To Parking Lots</label>
                        </div>
                        <div class="col-md-8">
                            <angular2-multiselect name="lots"
                                                  [data]="settingsParkingPassesService.parkingLotsInMultiselectFormat"
                                                  [(ngModel)]="data.parkingLots"
                                                  [settings]="multiselectSettings" required>
                            </angular2-multiselect>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/settings-parking-rules-modal/settings-parking-rules-modal.component.html